import React from 'react';
import { InformationCircle } from 'assets/icons';
import Tooltip from 'components/tooltips/Tooltips';

const OVERLAY_TOOLTIP_Z_INDEX = 100000;

const AdminSearchRulesTooltip = ({ zIndex }) => (
  <Tooltip
    zIndex={zIndex}
    text={
      <div className="text-xs space-y-1">
        <p className="font-semibold">Règles de recherche :</p>
        <p>• <span className="font-mono">&quot;mot&quot;</span> : recherche exacte</p>
        <p>• <span className="font-semibold">ET</span> : les deux termes requis</p>
        <p>• <span className="font-semibold">OU</span> : au moins un terme</p>
        <p>• <span className="font-semibold">NON</span> : exclure le terme</p>
        <p>• <span className="font-mono">( )</span> : grouper les opérations</p>
        <p>• <span className="font-mono">mot*</span> : recherche par préfixe</p>
        <p>• <span className="font-mono">mot~N</span> : recherche approximative</p>
        <p>• <span className="font-mono">&quot;phrase&quot;~N</span> : recherche de proximité</p>
        <p className="mt-1 text-gray-300">Ex : ingénieur ET (logiciel OU matériel)</p>
      </div>
    }
    placement="top"
  >
    <div className="cursor-pointer">
      <InformationCircle wh={16} color="#6B7280" />
    </div>
  </Tooltip>
);

export default AdminSearchRulesTooltip;
export { OVERLAY_TOOLTIP_Z_INDEX };
